import React, { useEffect } from 'react';
export const IframeResizer = () => {
  useEffect(() => {
    // Function to send height to parent
    const sendHeightToParent = () => {
      const height = document.documentElement.scrollHeight;
      console.log('Sending height:', height);
      if (window.parent !== window) {
        window.parent.postMessage({
          type: 'nuora-iframe-resize',
          height: height
        }, '*');
      }
    };
    // Send height multiple times during load to ensure it's captured
    setTimeout(sendHeightToParent, 100);
    setTimeout(sendHeightToParent, 300);
    setTimeout(sendHeightToParent, 500);
    setTimeout(sendHeightToParent, 1000);
    // Send height after any window resize
    window.addEventListener('resize', sendHeightToParent);
    // Use MutationObserver to detect DOM changes that might affect height
    const observer = new MutationObserver(() => {
      sendHeightToParent();
    });
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
    // Clean up
    return () => {
      window.removeEventListener('resize', sendHeightToParent);
      observer.disconnect();
    };
  }, []);
  return null; // This component doesn't render anything
};